
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Download } from 'lucide-react';
import { Contract } from './types';
import { generateContractContent } from './contractUtils';

interface ContractPreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contract: Contract | null;
  onDownload: (contract: Contract) => void;
}

const ContractPreviewDialog: React.FC<ContractPreviewDialogProps> = ({
  open,
  onOpenChange,
  contract,
  onDownload,
}) => {
  if (!contract) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>{contract.title}</DialogTitle>
          <DialogDescription>
            Contract preview. This is a sample template for reference only.
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[50vh] rounded-md border p-4">
          <div className="space-y-4">
            <pre className="whitespace-pre-wrap text-sm font-mono">
              {generateContractContent(contract)}
            </pre>
          </div>
        </ScrollArea>
        
        <div className="flex justify-end gap-2 mt-4">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
          <Button 
            onClick={() => onDownload(contract)}
            className="gap-2"
          >
            <Download className="h-4 w-4" />
            <span>Download</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContractPreviewDialog;
